import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx } from "react/jsx-runtime";
//#region src/components/PenPaper.tsx
const PenPaperIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M16.293 3.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-9 9A1 1 0 0 1 11 17H8a1 1 0 0 1-1-1v-3a1 1 0 0 1 .293-.707l9-9ZM9 13.414V15h1.586l8-8L17 5.414l-8 8ZM3 7a2 2 0 0 1 2-2h5a1 1 0 1 1 0 2H5v12h12v-5a1 1 0 1 1 2 0v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z",
		fill: props.fill || "currentColor"
	})
}));
//#endregion
export { PenPaperIcon };
